export default __webpack_public_path__ + "static/media/img_calendar_tag_rolling.4feed8c8.svg";